import React, {FC, KeyboardEvent, MouseEvent} from 'react'
import './LayoutContentTitle.less'

interface Props {
  title: string
  onSelect: () => void
  className?: string
}

export const LayoutContentTitle: FC<Props> = ({
                                                title,
                                                onSelect,
                                                className,
                                              }) => {
  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onSelect()
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      event.stopPropagation()
      onSelect()
    }
  }

  return (
    <div
      className={`layoutContentTitle${className ? ` ${className}` : ''}`}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {title}
    </div>
  )
}
